import { memo } from "react";
import { toKebabCase } from "common";
import type { Context } from "common/types/context";
import { LabelWidget } from "common/form/widget/label-widget";
import type { EntityColumn } from "common/entities/entity-column/types";

interface WorkOrderTitleProps {
  context: Context;
  value: any;
  column?: EntityColumn;
  label?: string;
  entityName: string;
  searchValue: string;
}

function WorkOrderTitleComp({
  context,
  value,
  column,
  label,
  entityName,
  searchValue,
}: WorkOrderTitleProps) {
  if (value == null) return null;

  const fieldId = toKebabCase(label ?? column?.name ?? "");

  return (
    <div
      className={`x-labeled-value qa-${fieldId}-field`}
      data-testid={fieldId ? `field-${fieldId}` : undefined}
    >
      {label && <div className="x-label">{label}:</div>}
      <div className="x-value">
        <LabelWidget
          context={context}
          entityName={entityName}
          column={column}
          withLinks={true}
          textToHighlight={searchValue}
          value={value}
        />
      </div>
    </div>
  );
}

export const WorkOrderTitle = memo(WorkOrderTitleComp);
